var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-subNav"},[_vm._l((_vm.sublist),function(item,index){return _c('a',{key:index,staticClass:"t",on:{"click":_vm.goback}},[_vm._v(_vm._s(item))])}),_c('a',{staticClass:"t"},[_vm._v("正文")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }